import { AlertVariantType } from "@src/constants/AlertVariantType";
import { ApiStatus } from "@src/constants/ApiStatus";
import { AlertService } from "./AlertService";

type SelectOption = {
    value: any,
    label: any
}

type ChartOption = {
    x: any,
    y: any
}

type SelectOptionReturnType = {
    data: Array<SelectOption>,
    apiData: Array<any>
}

type ChartOptionReturnType = {
    data: Array<ChartOption>,
    apiData: Array<any>
}

const ApiToInputDataTransformService = () => {
    const { AlertModel, ShowAlert } = AlertService();
    const GetTextValueOptions = (data: Array<any>, valueField: string, textField : string) : Array<SelectOption> => {
        let result : Array<SelectOption> = [];

        data.forEach(element => {
            if(element) {
                result.push({ label: element[textField], value: element[valueField] });
            }
        });
        return result;
    }
    const GetSelectInputOptions = 
        async (valueField: string, textField : string, fn: (query?: string) => any, query?: string): Promise<SelectOptionReturnType> => 
    {
        const queryString = query !== undefined ? query : '';
        const apiData = await fn(queryString);
        if (apiData?.status === ApiStatus.Success) {
            const transformedData = GetTextValueOptions(apiData.data?.results, valueField, textField);
            return { data: transformedData, apiData: apiData.data?.results };
        }
        AlertModel.variant = AlertVariantType.ERROR;
        AlertModel.message = apiData.message
        ? apiData.message
        : apiData.data.message;
        AlertModel.visible = true;
        await ShowAlert(AlertModel);

        return { data: [], apiData: [] };
    }
    const TransformedToChartData = (data: Array<any>, xField : string, yField: string) : Array<ChartOption> => {
        let result : Array<ChartOption> = [];

        data.forEach(element => {
            if(element) {
                result.push({ x: element[xField], y: element[yField] });
            }
        });
        return result;
    }
    const GetChartData = 
        async (xField: string, yField : string, fn: (query?: string) => any, query?: string): Promise<ChartOptionReturnType> => 
    {
        const queryString = query !== undefined ? query : '';
        const apiData = await fn(queryString);
        if (apiData?.status === ApiStatus.Success) {
            const transformedData = TransformedToChartData(apiData.data?.results, xField, yField);
            return { data: transformedData, apiData: apiData.data?.results };
        }
        AlertModel.variant = AlertVariantType.ERROR;
        AlertModel.message = apiData.message
        ? apiData.message
        : apiData.data.message;
        AlertModel.visible = true;
        await ShowAlert(AlertModel);

        return { data: [], apiData: [] };
    }
    return { GetSelectInputOptions, GetTextValueOptions, GetChartData };
}

export { ApiToInputDataTransformService }